import Icon from 'components/icon';
import useOnClickOutside from 'models/utils/useOnClickOutside';
import { ReactNode, useRef } from 'react';
import styles from './styles.module.scss';

type Modal = {
  title?: string,
  children : ReactNode,
  closeModal: () => void
}

function Modal(props : Modal) : JSX.Element {
  const modalRef = useRef<HTMLDivElement>(null);

  useOnClickOutside(modalRef, props.closeModal, ['react-select']);

  return (
    <div id={styles['biobar-overlay']}>
      <div id={styles['biobar-modal']} ref={modalRef}>
        <div id={styles['biobar-header']}>
          {props.title && <h3 id={styles['biobar-title']}>{props.title}</h3>}
          <Icon className={!props.title ? styles['biobar-close-button'] : ''}
            onClick={props.closeModal}
            iconName='close' />
        </div>
        <div id={styles['biobar-content']}>
          {props.children}
        </div>
      </div>
    </div>
  );
}

export default Modal;